import type { Localization } from './localization.types'

export const locales: Localization.LocaleList = ['nl', 'en', 'de', 'fr']
export const defaultLang: Localization.Locale = 'en'

export type PerLanguage<T> = {
    en: T
    nl: T
    de: T
    fr: T
}

/**
 * Record with slugs in each supported language for a particular model/entity
 */
export type Slugs = PerLanguage<string>
